// Default English copy for <RichTextEditor>. Hosts translate it through AdminUiProvider (../i18n)
// and may still override `label` per field.

export interface RichTextEditorLabels {
  label: string
  toolbarLabel: string
  paragraph: string
  heading2: string
  heading3: string
  bold: string
  italic: string
  underline: string
  strike: string
  orderedList: string
  bulletList: string
  blockquote: string
  horizontalRule: string
  link: string
  linkPrompt: string
  image: string
  table: string
  addRow: string
  addColumn: string
  deleteTable: string
  undo: string
  redo: string
  help: string
}

export const RICH_TEXT_EDITOR_COPY: RichTextEditorLabels = {
  label: 'Content',
  toolbarLabel: 'Text formatting',
  paragraph: 'Paragraph',
  heading2: 'Heading',
  heading3: 'Subheading',
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strike: 'Strikethrough',
  orderedList: 'Numbered list',
  bulletList: 'Bulleted list',
  blockquote: 'Quote',
  horizontalRule: 'Divider',
  link: 'Link',
  linkPrompt: 'Link URL (https://…, /path, mailto:) — leave empty to remove',
  image: 'Insert image',
  table: 'Insert table',
  addRow: 'Add row below',
  addColumn: 'Add column right',
  deleteTable: 'Delete table',
  undo: 'Undo',
  redo: 'Redo',
  help: 'Headings, lists, quotes, links, images and tables. Pasted formatting outside this set is removed.',
}
